class ArticleRepository {
    /**
     * @param {number} limit
     * @param {string} [startAfterId] - The ID of the last article from the previous fetch, for pagination.
     * @returns {Promise<Article[]>}
     */
    async getArticles(limit, startAfterId) {
        throw new Error('Method not implemented.');
    }

    /**
     * @param {string} id
     * @returns {Promise<Article>}
     */
    async getArticleById(id) {
        throw new Error('Method not implemented.');
    }

    /**
     * @param {object} articleData
     * @returns {Promise<Article>}
     */
    async createArticle(articleData) {
        throw new Error('Method not implemented.');
    }

    /**
     * @param {string} id
     * @param {object} updates
     * @returns {Promise<void>}
     */
    async updateArticle(id, updates) {
        throw new Error('Method not implemented.');
    }

    /**
     * @param {string} id
     * @returns {Promise<void>}
     */
    async deleteArticle(id) {
        throw new Error('Method not implemented.');
    }

    /**
     * @returns {Promise<string[]>}
     */
    async getArticleCategories() {
        throw new Error('Method not implemented.');
    }
}

export default ArticleRepository;
